import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const FeatureGames = ({slidersFavourite, slidersFeatures}) => {
    

      
      const [isLoading, setIsLoading] = useState(false);
      const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token')); 
      const [isMobile, setIsMobile] = useState(false);
      const navigate = useNavigate();
      const [error, setError] = useState(null);
      const origin = window.location.origin;
     
    
     
      const handleGameClick = async (gameCode) => {
        if(!isLoggedIn) {
          navigate('/login');
        }
        setIsLoading(true);
  
          try {
              const token = localStorage.getItem('token');
              const remote_id = localStorage.getItem('remote_id');
              if (!token) {
                  setError('User not logged in');
                  return;
              }
              let parts = gameCode.split('-');

                  // Assign platform, gameType, and the original gameCode
                  let platform = parts[0];   // "EVOLUTION"
                  let gameType = parts[1];   // "LIVE"
                  console.log(platform, gameType, gameCode);
            
              const response = await fetch(`${process.env.REACT_APP_API_URL}/api/game-run`, {
                  method: 'POST',
                  headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}`,
                  },
                 
                  body: JSON.stringify({
                     userId : remote_id,
                     externalURL: origin,
                     isMobileLogin: isMobile,
                     gameCode:gameCode,
                     gameType: gameType,
                     platform: platform
                     
                     
                  }),
                 
              });
  
              const data = await response.json();
              if (response.ok) {
                  console.log(data.url);
                  navigate('/gamerun', { state: { iframeUrl: data.url } });
              } else {
                  setError(data.message || 'An unexpected error occurred');
              }
          } catch (error) {
              setError('An unexpected error occurred');
          }
          finally {
              setIsLoading(false);
          }
      };
    

    
    

    return (
        <div className="hot-game-container">
        <div className="game-title-wrap">
          <h2 className="game-title-text"><img className="game-title-icon" src="https://www.jita88.cc/m/icon-hot.377f44e6.png" /><span>Featured Games</span></h2>
        </div>
        <div className="hot-game-wrap swiper-container-initialized swiper-container-horizontal">
          <div className="swiper-wrapper" style={{overflow: 'auto'}}>
          {slidersFeatures.length > 0 ? (
                            slidersFeatures.map((game, index) => (
            <div  onClick={() => handleGameClick(game.link)} className="swiper-slide hot-box " style={{marginRight: '9.6px'}} key={index}>
              <div className="game-list-item">
                <div className="top-content">
                  <img className="game-pic"  src={`${process.env.REACT_APP_API_URL}/storage/${game.thubmnail}`}  alt="" />
                  <div className="vendor-icon-wrap"><img className="vendor-icon"  src={`${process.env.REACT_APP_API_URL}/storage/${game.thubmnail}`}  alt="" /></div>
                </div>
                <div className="game-item-wrap">
                  <span className="game-item-name">
                  {game.name}
                    
                  </span>
                  <div className="favorite_icon hot">
                    <svg className="am-icon am-icon-icon-heart_1aa20fd2 am-icon-md"><use xlinkHref="#icon-heart_1aa20fd2" /></svg>
                  </div>
                </div>
              </div>
            </div>
           ))
        ) : (
            <p></p>
        )}
       
          </div>
          <div className="swiper-wrapper" style={{overflow: 'auto'}}>
          {slidersFavourite.length > 0 ? (
                            slidersFavourite.map((game, index) => (
            <div onClick={() => handleGameClick(game.link)} className="swiper-slide hot-box " style={{marginRight: '9.6px'}} key={index}>
              <div className="game-list-item">
                <div className="top-content">
                  <img className="game-pic"  src={`${process.env.REACT_APP_API_URL}/storage/${game.thubmnail}`}  alt="" />
                  <div className="vendor-icon-wrap"><img className="vendor-icon"  src={`${process.env.REACT_APP_API_URL}/storage/${game.thubmnail}`}  alt="" /></div>
                </div>
                <div className="game-item-wrap">
                  <span className="game-item-name">
                  {game.name}
                    
                  </span>
                  <div className="favorite_icon hot">
                    <svg className="am-icon am-icon-icon-heart_1aa20fd2 am-icon-md"><use xlinkHref="#icon-heart_1aa20fd2" /></svg>
                  </div>
                </div>
              </div>
            </div>
           ))
        ) : (
            <p></p>
        )}
       
          </div>
          <div className="swiper-scrollbar">
            <div className="swiper-scrollbar-drag" style={{transform: 'translate3d(0px, 0px, 0px)', width: '61.8216px'}} /></div>
          <span className="swiper-notification" aria-live="assertive" aria-atomic="true" />
        </div>
      </div>
    );
};

export default FeatureGames;